import BaseCommand from "@/models/api/commands/BaseCommand";

export class DeleteOrderItemCommand extends BaseCommand {
  CommandName = "DeleteOrderItem";
  Command: string;
  constructor(sessionId: string, operationId: string, orderItemId: string) {
    super(sessionId, operationId);
    this.Command = orderItemId;
  }
}
